"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPLOYEE_TYPE_ITEMS = void 0;
exports.EMPLOYEE_TYPE_ITEMS = [
    { code: "Full-time", label: "Full-time" },
    { code: "Part-time", label: "Part-time" },
    { code: "Contract", label: "Contract" },
    { code: "Internship", label: "Internship" },
    { code: "Freelance", label: "Freelance" },
    { code: "Other", label: "Other" },
];
